export default __webpack_public_path__ + "static/media/tab_user-plus-solid.31909e42.svg";